module.exports = __webpack_public_path__ + "assets/img/rule_3.e9ae8706.png";